import { MultimediaView } from "@mirage/shared/search/search-result";

import type { SearchFilter } from "@mirage/shared/search/search-filters";
import { isInsideExtensionSidePanel } from "@mirage/shared/util/webExtensionsHelpers";

export const useMultimediaView = (filters: SearchFilter[]): MultimediaView => {
  if (isInsideExtensionSidePanel()) {
    return MultimediaView.OFF;
  }
  if (
    filters.find((filter) => filter.id === "image" || filter.id === "video")
  ) {
    return MultimediaView.V1;
  }
  return MultimediaView.OFF;
};
